// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1zSL_","blue":"Button_blue__1k_Ox"};